module.exports = __webpack_public_path__ + "675e3a61190faeba47049acc9a529149.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/advanced_micro_devices_2023_chart.png
// module id = 1626
// module chunks = 0